module.exports = __webpack_public_path__ + "fonts/mem5YaGs126MiZpBA-UN8rsOX-hpOqc.fc29cd59.woff2";